import { render } from "./propertyiconeditor.vue?vue&type=template&id=10a3916a"
import script from "./propertyiconeditor.vue?vue&type=script&lang=js"
export * from "./propertyiconeditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/propertyiconeditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10a3916a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10a3916a', __exports__)) {
    api.reload('10a3916a', __exports__)
  }
  
  module.hot.accept("./propertyiconeditor.vue?vue&type=template&id=10a3916a", () => {
    api.rerender('10a3916a', render)
  })

}


export default __exports__